<template>
 <div>
 <table style="position: absolute;" width="100%"  :height="this.windowSize.height-8"  :max-height="this.windowSize.height-8" >
  <tr max-height="48px" height="48px"  >
  <ContenidoBase 
  :titulo="'Productos Vendido por Vendedor y Laboratorio'"
  :descripcion="'Imprime un listado de los producto vendido por vendedor.'"
   :EstadoBtn="EstadoBtn"
   @abrirBarraTablaDinamica="abrirTabla"
   @MethodNuevo="newwnuevo"
   @MethodGuardar="save"
   @MethodEliminar="remove"
   @MethodAnular="anular"
   @MethodImprimir="imprimirList"
   
/>
    </tr>
  
    <tr>
<!-- BarraPrimaria --------------------------------------------------------------------------------->
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraTablaDinamicaAprir">

         <div class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px'  }">
        
        <v-tooltip left>
          <template v-slot:activator="{ on }">
              <center>
              <v-btn-toggle>
                <v-btn
                  small
                  color="yellow accent-4"
                  @click.prevent="actualiza_tb_ver"
                >
                  <i style="font-size: 25px;" class="fa fa-eye"> </i> ver</v-btn
                >
                <v-btn
                  small
                  dark
                  color="deep-purple accent-2"
                  @click.prevent="notifi('Seguro que desea nuevo', 'n')"
                >
                  <i style="font-size: 25px;" class="fa fa-print"> </i>
                  Listado</v-btn
                >
              </v-btn-toggle>
            </center>
            <!-- <BarraBusqueda2
              :url="
                $hostname + $hName + '/services/tipocliente/findalltipoclientes'
              "
              :nombre="'Tipo de Clientes'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitReportesProductoVendido'"
              :SeachNombre="'Búsqueda por descripcion '"
              :slotlist="slotlist"
            /> -->
          </template>
        </v-tooltip>

      </div>
      </td>
<!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
<!-- contenido central ------------------------------------------------------------------------------ -->
      <td :max-height="this.windowSize.height-96" >
        <v-app id="inspire" class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' }">
 

 <v-container >
  <v-card color="grey lighten-3">

<v-toolbar
        flat
        color="#BDBDBD"
        dense
        style="border: 1px solid #000000;"
      >
        
  
 <v-avatar tile  size="45"  >
      <img
        src="@/assets/iconos_micromarket/custom-reports.png"
        alt="Reporte"
      >
    </v-avatar>

    
<span class="font-weight-light" style="font-size: 20px;"> Listado de productos Vendido por Vendedor y Laboratorio </span >

  <!-- <v-toolbar-title    class="font-weight-light"> Reporte Producción de boletos por unidades</v-toolbar-title > -->
   <!-- style="color:white;" -->
    <!-- <i class=""> </i> -->

        <!-- <v-spacer></v-spacer> -->
        <!-- <v-btn
          color="grey darken-4"
          fab
          small
          @click="cerrarmodalcuenta"
        >
         <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
        </v-btn> -->
      </v-toolbar>
           
<hr>

  <v-container style="border: 1px solid #000000;">
  <v-form ref="form" @submit.prevent=""  v-model="valid" lazy-validation>
              <v-row>
<!-- columna 1 -->
<v-col cols="12" md="6" sm="6">

  <!-- -----------------------------  desde  -->
<v-text-field
        dense
        outlined
        type="date"  
        label="Fecha Incial:"
        v-model="ProductoVendido.desde"
        @blur="BlurDesde"
        >
                <template v-slot:prepend>
                  <i style="font-size: 20px;" class="fa fa-calendar"></i>
                </template>
                </v-text-field>


    <v-combobox                 
                        autocomplete="off"
                        dense
                        outlined
                        label="Fabricante:"
                        :items="RFabricante"
                        item-text="nombre"
                        v-model="ProductoVendido.fabricante"  
                        @focus="CargarFabricante"
                        @blur="SelctCbFabricante"
                      >
                        <template v-slot:prepend>
                          <i
                            style="font-size: 20px;"
                            class="fa fa-wrench"
                          ></i>
                        </template>
                      </v-combobox>

<v-combobox
            autocomplete="off"
            dense
            outlined
            label="Sucursales:"
            :items="Rsucursal"
            item-text="descripcion"
            v-model="ProductoVendido.sucursal"
            @focus="cargarSucursal"
            @blur="SelctCbSucursal"
          
          >
            <template v-slot:prepend>
              <i style="font-size: 20px;" class="fa fa-sitemap"></i>
            </template>
          </v-combobox>


</v-col>
<!-- fn columna 1 -->


<!-- columna 2 -->
<v-col cols="12" md="6" sm="6">


 <!-- -----------------------------  hasta  -->
<v-text-field
        dense
        outlined
        type="date"  
        label="Fecha Final:"
        v-model="ProductoVendido.hasta"
        @blur="BlurHasta"
        >
                <template v-slot:prepend>
                  <i style="font-size: 20px;" class="fa fa-calendar"></i>
                </template>
                </v-text-field>


 <!-- ----------------------------- vendedores -->
<v-combobox
            autocomplete="off"
            dense
            outlined
            label="Vendedores:"
            :items="RVendedores"
            item-text="nombre"
            v-model="ProductoVendido.vendedores"
            @blur="SelctCbVendedores"
            @focus="cargarVendedores"
          >
            <template v-slot:prepend>
              <i style="font-size: 20px;" class="fa fa-sign-language"></i>
            </template>
          </v-combobox>



</v-col>
<!-- fn columna 2 -->
         
              </v-row>

            </v-form>
       </v-container>

<hr>

<ModalReporteFiltros
 ref="ModRepFilt"
@DataReporteBasico="DDataReporteBasico"
:Datos="ProductoVendidoLink"
/>


  </v-card>
 </v-container>

        </v-app> 
      </td>
<!-- fn contenido central ------------------------------------------------------------------------------------->
<!-- BarraSecundaria ------------------------------------------------------------------------------------------>
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraSecundariaAprir" >

 <div  class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px' }">
        
<!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
</div>

      </td>
<!-- fn BarraSecundaria --------------------------------------------------------------------------------------->



    </tr>
  </table>
<!-- Modales -------------------------------------------------------------------------------------------------->
  <!-- ------------------------------------------------------ tb-data-->
    <v-dialog
      label="myAlert"
      v-model="acti_tb_data"
      persistent
      max-width="100%"
      max-height="100%"
      transition="fab-transition"
    >
      <v-card>
        <v-toolbar flat color="#BDBDBD">
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"></i>
          <v-toolbar-title class="font-weight-light"> REPORTE </v-toolbar-title>
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"> </i>

          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            fab
            small
            @click="acti_tb_data = !acti_tb_data"
          >
            <i style="font-size: 20px; color:#dd4b39;" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field
                v-model="search"
                @keyup="filtro"
                label="Buscar"
                single-line
                hide-details
              >
                <template v-slot:prepend-inner>
                  <i style="font-size: 35px;" class="fa fa-search"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table
              :headers="slotHtabla"
              dense
              :items="list"
              :search="search"
              @click:row="datostabla"
            >
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog
      label="myAlert"
      v-model="Elim_notif.estado"
      persistent
      max-width="350"
      transition="fab-transition"
    >
      <template justify="center" v-slot:activator="{ on }"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i style="font-size: 28px;" class="fa fa-warning"></i>
            CONFIRMACION
            <i style="font-size: 28px;" class="fa fa-warning"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn
            @click.prevent="
              eliminar(), (Elim_notif.estado = !Elim_notif.estado)
            "
            small
          >
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
          </v-btn>

          <v-btn @click.prevent="Elim_notif.estado = !Elim_notif.estado" small>
            <i style="font-size: 20px;" class="fa fa-ban"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      style="margin-top: 20%;"
      :vertical="true"
      :timeout="120000"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

<!-- fn Modales ----------------------------------------------------------------------------------------------->


  </div>
</template>

<script>
import { EventBus } from "../../event-bus";
import BarraBusqueda2 from "../../components/BarraBusquedaDinam";
import ContenidoBase from "../../components/ContenidoBase";
import ModalReporteFiltros from "../../components/ModalReporteFiltros2";
import { currencyFormatter,
  FormatoFecha,
  HoraFormatter,
  HoraFormatter2,
  RedondeoValor,
  RedondeoBasico,
  RedondeoValorCantRed,
  fechaNueva,
  getParamFecha
} from "@/js/Funciones.js";
export default {
  components: {
    BarraBusqueda2,
    ContenidoBase,
    ModalReporteFiltros
  },
  created() { 
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
    EventBus.$on("emitReportesProductoVendido", this.datostabla);
    EventBus.$on("onResize", this.onResize);

    this.$refs.ModRepFilt.CrearObjecto=this.validarObjecto;

  },

  data:()=>  ({

      ListaTiposClientes: [],
      RFabricante:[],
      RVendedores:[],
      Rsucursal:[],
      windowSize:{width:"auto", height:"auto"},
      

ProductoVendidoLink:{
        nombre:'LISTADO PRODUCTO VENDIDO',
        UrlImprimir: '/reportesInv/vendedorlavoratorio', 
        UrlExel: '/reportesInv/excel-vendedorlavoratorio', 
        UrlCorreo: '/reportesInv/correo-vendedorlavoratorio',
},
      
      ProductoVendido: {
        desde: fechaNueva(),
        hasta: fechaNueva(),
        fabricante:null,
        vendedores:null,
        sucursal:null
      },

EstadoBtn:{ 
        BarraTablaDinamicaAprir:false,
        nuevo:false,
        guardar:false,
        eliminar:false,
        anular:false,
        imprimir:false,
        vercuenta:false,
        guardartemporal:false,
        restaurartemporal:false,
        importarDato:false,
        cargarProducto:false,
        ImprimirproductoInv:false,
        },


     
      text: "",
      valid: true,
     BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,

      headers: [{ text: "Tipo Clientes", value: "descripcion" }],

      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        {
          dt0: "descripcion",
          dt1: null,
          dt2: null,
          dt3: 1,
          dt4: "Descripcion:"
        },
        { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
      ],

      slotHtabla: [
        { text: "Código", value: "codigo" },
        { text: "Descripcion", value: "descripcion" }
      ],

      list: [],
      search: "",
      acti_tb_data: false,
      Elim_notif: {
        estado: false,
        nombre: "¿Seguro que desea anular este registro?"
      },

      aalert: {
        estado: false,
        color: null
      },
    
    }),


  //   destroyed() {
  //     location.reload();
  //   },
  methods: {
    currencyFormatter,
  FormatoFecha,
  HoraFormatter,
  HoraFormatter2,
  RedondeoValor,
  RedondeoBasico,
  RedondeoValorCantRed,
  fechaNueva,
  getParamFecha,
onResize(e){

this.windowSize=e


},

    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir;
    },

    datostabla(e) {

      this.ProductoVendido = e;
      this.acti_tb_data=false
    },
    save() { },
    remove() { },
    eliminar() { },
    anular() { },
    imprimirList() {},

DDataReporteBasico(){},

    validarObjecto(){

if (!this.$refs.form.validate()){
  this.$refs.ModRepFilt.detener=true;
  return ;
}else{
  this.$refs.ModRepFilt.detener=false;
}

var where=` subqry.activada=true and subqry.fecha>= ' ${this.ProductoVendido.desde} ' and subqry.fecha  <=' ${this.ProductoVendido.hasta} '`

//this.VentasProductosClientes

if(this.ProductoVendido.fabricante !=null){
  where+=` and subqry.codfabr= ${this.ProductoVendido.fabricante.codigo} `
  this.ProductoVendidoLink.fabricante=JSON.parse(JSON.stringify(this.ProductoVendido.fabricante.nombre))
}
        
if(this.ProductoVendido.vendedores !=null){
  where+=` and subqry.codven= ${this.ProductoVendido.vendedores.codigo} `
  this.ProductoVendidoLink.vendedor=JSON.parse(JSON.stringify(this.ProductoVendido.vendedores.nombre))
}    

if(this.ProductoVendido.sucursal !=null){
  where+=` and subqry.codsuc= ${this.ProductoVendido.sucursal.codigo} `
  this.ProductoVendidoLink.sucursal=JSON.parse(JSON.stringify(this.ProductoVendido.sucursal.descripcion))
}    

this.ProductoVendidoLink.where=where
this.ProductoVendidoLink.desde=this.ProductoVendido.desde
this.ProductoVendidoLink.hasta=this.ProductoVendido.hasta

},


    newwnuevo() {
      (this.ProductoVendido = {
        activo: true,
        borrado: false,
        codigo: 0,
        descripcion: "",
        descripcionOriginal: "",
        fechaCreacion: "",
        fechaModificacion: "",
        usuarioCreacion: "",
        usuarioModificacion: ""
      }),
        EventBus.$emit("actualizaBarraBusqueda2");
    },



SelctCbFabricante(){
 if(this.ProductoVendido.fabricante==null){

    this.ProductoVendido.fabricante=''
  }

if(this.ProductoVendido.fabricante.codigo==undefined){

// this.alerta("Seleccione un fabricante", "error");
this.ProductoVendido.fabricante=''
return

}

},


CargarFabricante(){
this.$axios
          .get(
              this.$hostname + this.$hName + "/fabricante/activo",
              {
                headers: this.$store.getters.GetheadersAxios
              }
          ).then(res => this.RFabricante = res.data)
          .catch()
},



cargarVendedores(){

this.$axios.get(this.$hostname+this.$hName+'/vendedores/findall',{headers:this.$store.getters.GetheadersAxios})
.then(res=>( this.RVendedores=res.data))

},

SelctCbVendedores(){

 if(this.ProductoVendido.vendedores==null){

    this.ProductoVendido.vendedores=''
  }

if(this.ProductoVendido.vendedores.codigo==undefined){

this.alerta("Seleccione un vendedor", "error");
this.ProductoVendido.vendedores=''
return

}

},



cargarSucursal(){


var headers=this.$store.getters.GetheadersAxios
this.$axios.get(this.$hostname + this.$hName + "/sucursal/findallActivos/",{headers:headers})
        .then(res => {this.Rsucursal = res.data})
        .catch(error => console.log(error));

},


SelctCbSucursal(){

  if(this.ProductoVendido.sucursal==null){

    this.ProductoVendido.sucursal=''
  }

if(this.ProductoVendido.sucursal.codigo==undefined){

// this.alerta("Seleccione una Sucursal", "error");
this.ProductoVendido.sucursal=''
return

}

},




BlurDesde(){

if(this.ProductoVendido.desde.toString().length==0){
  this.ProductoVendido.desde=this.fechaNueva()
}

 },


 BlurHasta(){

if(this.ProductoVendido.hasta.toString().length==0){
  this.ProductoVendido.hasta=this.fechaNueva()
}

 },




    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);

        this.newwnuevo();
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);

        this.ejecucion = false;
      }
    },




    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data;
      this.filtro();
    },

    async filtro() {}
  }
};
</script>

<style></style>
